export default __webpack_public_path__ + "static/Modulr_(MFSL)_-_UK_Safeguarding_Explanation_-_Jun_2021-346396693e03248bec3240115ed36cfe.pdf";